import _ from 'lodash';

export const getMusicState = state => _.get(state, 'music');
